module.exports = __webpack_public_path__ + "img/filter.fe0deb57.svg";